import { QueryKeyConfig } from './api-helper';

export const stateApiKeyStore = {
    getStates: (): QueryKeyConfig => ({
        queryKey: [`GET_STATES`],
        route: `/State`,
    }),
};
